import { FC, useState } from 'react';
import { Box, Button, SxProps, Theme } from '@mui/material';
import { useSelector } from 'react-redux';
import {
	getPaymentMethodsBlockedMessage,
	getPaymentMethodsSummary,
} from 'redux/reducers/paymentMethods/selectors';
import { BlockedTooltip } from '../ClientAccess';
import { DirectDebitModal } from './DirectDebitModal';
import directDebitSvg from './DirectDebitSvg/direct-debit-1.svg';

type TDirectDebitProps = {
	buttonSx?: SxProps<Theme>;
};

/**
 * "Set up Direct Debit": only for clients the gateway allows Direct Debit for (UK-registered clients,
 * `summary.directDebitAvailable`). Several mandates are allowed, each for its own services; the mandates
 * themselves are listed in the payment methods table.
 */
export const DirectDebit: FC<TDirectDebitProps> = ({ buttonSx }) => {
	const summary = useSelector(getPaymentMethodsSummary);
	// a new mandate is blocked by the operator
	const blockedMessage = useSelector(getPaymentMethodsBlockedMessage);
	const [open, setOpen] = useState(false);

	if (!summary?.directDebitAvailable) return null;

	return (
		<>
			<BlockedTooltip message={blockedMessage}>
				<Button variant="contained" onClick={() => setOpen(true)} disabled={!!blockedMessage}>
					Set up Direct Debit
				</Button>
			</BlockedTooltip>
			<DirectDebitModal open={open} onClose={() => setOpen(false)} />
		</>
	);
};
